import { useEffect } from 'react';

/**
 * モーダルが開いているときにbodyのスクロールを禁止するフック
 * @param isLocked スクロールをロックするかどうか
 */
export function useLockBodyScroll(isLocked: boolean): void {
  useEffect(() => {
    if (!isLocked) return;

    const originalStyle = window.getComputedStyle(document.body).overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = originalStyle;
    };
  }, [isLocked]);
}
